import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { ExportViewProps, ExportViewRef } from "./models";
import SearchFilter, { Filters } from "../../../Common/SearchFilter/SearchFilter";
import { searchFilterToExportExcelFilter } from "../../../Common/SearchFilter/utils";
import useDidMountEffect from "../../../Common/UseDidMountEffect";
import { ApiBackend } from "../../../../providers/apibackend";
import { Product } from "../../../../model/Product";

type SearchFilterType = {
    productId?: string;
};

interface ISearchFilter {
    productId?: string;
}

const Orders = forwardRef<ExportViewRef, ExportViewProps>((props, ref) => {
    const [searchFilter, setSearchFilter] = useState(null as ISearchFilter);
const [products, setProducts] = useState(null as Product[]);
    useImperativeHandle(ref, () => ({
        isValid: () => {
            return !!searchFilter?.productId;
        }
    }));

    useEffect(() => {
        let backend = new ApiBackend();
        backend.listProducts(false).then((res) => {
            res.sort((x,y) => {return x.name < y.name ? -1 : 1});
            setProducts(res);
        });
    },[]);

    useDidMountEffect(() => {
        props.onChange(searchFilterToExportExcelFilter<ISearchFilter>(searchFilter));
    }, [searchFilter]);

    const render = () => {
        return (
            <SearchFilter<SearchFilterType>
                id={"export-orders-filter"}
                filters={{
                    "productId": {
                        id: "filter-productId",
                        type: "GenericSelect",
                        label: "Produkt",
                        size: 12,
                        multiple: false,
                        itemDefinition: {
                            items: products == null ? [] : products.map(x=>{ return {name: x.name, value:x.id}}),
                            itemValueType: "string"
                        }
                    }
                }}
                persist={true}
                onInit={(filter: Filters<SearchFilterType>) => {
                    setSearchFilter(filter as unknown as ISearchFilter);
                }}
                onChange={(filter: Filters<SearchFilterType>) => {
                    setSearchFilter(filter as unknown as ISearchFilter);
                }}
            />
        );
    };

    return render();
});

export default Orders;
